import React from 'react';
import { logGresku } from '../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { imaGresku: false, greska: null };
  }

  static getDerivedStateFromError(error) {
    return { imaGresku: true, greska: error };
  }

  componentDidCatch(error, info) {
    logGresku({
      tip: 'react_crash',
      poruka: error.message,
      stack: (error.stack || '') + '\n\nComponent stack:\n' + (info.componentStack || ''),
      strana: 'react-render',
      korisnik: 'auto',
    });
  }

  render() {
    if (this.state.imaGresku) {
      return (
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          height: '100vh', background: '#0f0f1a',
        }}>
          <div style={{
            background: '#16162a', border: '1px solid #e94560', borderRadius: '12px',
            padding: '32px', maxWidth: '500px', textAlign: 'center',
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>💥</div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#fff', marginBottom: '8px' }}>
              Doslo je do greske
            </div>
            <div style={{ fontSize: '14px', color: '#e94560', marginBottom: '8px', fontFamily: 'monospace' }}>
              {this.state.greska?.message}
            </div>
            <div style={{ fontSize: '12px', color: '#666688', marginBottom: '20px' }}>
              Greska je automatski zabilježena.
            </div>
            <button
              onClick={() => { this.setState({ imaGresku: false, greska: null }); window.location.reload(); }}
              style={{
                padding: '10px 24px', background: '#e94560', color: 'white',
                border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px',
              }}>
              Ponovo ucitaj stranicu
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
